<template>
  <div class="language-selector hidden-print-only">
    <button
      v-if="sidebar"
      type="button"
      class="sidebar-trigger"
      :aria-label="`${$t('languageSelector.title')}: ${selectedLanguage.name}`"
      @click="dialog = true"
    >
      <PosUiIcon name="translate" class="trigger-icon" />
      <span class="trigger-label">{{ selectedLanguage.name }}</span>
    </button>
    <span v-else @click="dialog = true">{{ selectedLanguage.name }}</span>
    <v-dialog v-model="dialog" max-width="320">
      <v-card>
        <v-card-title class="headline">
          {{ $t('languageSelector.title') }}
        </v-card-title>

        <v-card-text class="language-list">
          <v-btn
            v-for="lang of langs"
            :key="lang.id"
            text
            block
            class="language-option"
            :class="{ 'language-option--active': lang.id === currentLanguage }"
            @click="setLang(lang)"
          >
            {{ lang.name }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import PosUiIcon from '@/components/pos-v2/ui/PosUiIcon.vue';
  import {
    i18n,
    loadLanguageAsync,
    SUPPORTED_LANGUAGES,
    ILanguageOption,
  } from '../plugins/i18n';

  @Component({ components: { PosUiIcon } })
  export default class LanguageSelector extends Vue {
    /** Renders a drawer row trigger (restaurant sidebar) instead of the bare span. */
    @Prop({ type: Boolean, default: false }) sidebar: boolean;

    langs: ILanguageOption[] = SUPPORTED_LANGUAGES;
    dialog = false;

    selectedLanguage = this.langs[0];

    mounted() {
      this.checkLang();
    }

    setLang(lang) {
      loadLanguageAsync(lang.id);
      this.dialog = false;
    }

    @Watch('currentLanguage')
    onLangChange(newValue, oldValue) {
      this.checkLang();
    }

    get currentLanguage() {
      return i18n.locale;
    }

    private checkLang() {
      const curr = this.currentLanguage;
      for (let lang of this.langs) {
        if (lang.id === curr) {
          this.selectedLanguage = lang;
          break;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .language-list {
    @apply tw-max-h-[60vh] tw-overflow-y-auto tw-pb-4;

    .language-option {
      @apply tw-justify-start tw-normal-case;

      &--active {
        @apply tw-font-bold;
      }
    }
  }

  .sidebar-trigger {
    @apply tw-flex tw-min-h-[44px] tw-w-full tw-cursor-pointer tw-select-none tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-px-4 tw-py-2 tw-transition-colors;

    &:hover {
      @apply tw-bg-neutral-50;
    }

    &:focus-visible {
      @apply tw-outline-none tw-ring-2 tw-ring-inset tw-ring-orange-500/40;
    }

    .trigger-icon {
      @apply tw-mr-2 tw-text-base tw-text-neutral-500;
    }

    .trigger-label {
      @apply tw-text-[13px] tw-text-neutral-600;
    }
  }
</style>
